package link.erpango.quip.domain.noteimport

/**
 * Required fields of each draft, mirroring the validation of the creation forms
 * (AddVehicleScreen, AddMaintenanceScreen and MySparePartEditViewModel.save()). The review
 * UI flags what is missing, and nothing is created while a required field is empty.
 */
enum class VehicleField { VIN, PLATE, BRAND, MODEL, YEAR, COLOR, OWNER }

enum class MaintenanceField { VEHICLE, DATE, KILOMETERS, COST }

enum class SparePartField { CATEGORY, TYPE, BRAND, MODEL }

fun VehicleDraft.missingRequired(): Set<VehicleField> = buildSet {
    if (vin?.value.isNullOrBlank()) add(VehicleField.VIN)
    if (plate?.value.isNullOrBlank()) add(VehicleField.PLATE)
    if (brand?.value.isNullOrBlank()) add(VehicleField.BRAND)
    if (model?.value.isNullOrBlank()) add(VehicleField.MODEL)
    if (year == null) add(VehicleField.YEAR)
    if (color?.value.isNullOrBlank()) add(VehicleField.COLOR)
    if (owner?.value.isNullOrBlank()) add(VehicleField.OWNER)
}

fun MaintenanceDraft.missingRequired(): Set<MaintenanceField> = buildSet {
    if (vehicle == VehicleRef.Unassigned) add(MaintenanceField.VEHICLE)
    if (date == null) add(MaintenanceField.DATE)
    if (kilometers == null) add(MaintenanceField.KILOMETERS)
    if (cost == null) add(MaintenanceField.COST)
}

fun SparePartDraft.missingRequired(): Set<SparePartField> = buildSet {
    if (categoryId?.value.isNullOrBlank()) add(SparePartField.CATEGORY)
    if (typeId?.value.isNullOrBlank()) add(SparePartField.TYPE)
    if (brand?.value.isNullOrBlank()) add(SparePartField.BRAND)
    if (model?.value.isNullOrBlank()) add(SparePartField.MODEL)
}
